import { Link } from "react-router-dom";
import { CalendarDays, HardHat, Truck } from "lucide-react";
import { ftime } from "../../api";
import { Avatar, Badge } from "../bits";
import { EmptyLine, HomeSection, plural } from "./HomeBits";

const ICON = { job: HardHat, appointment: CalendarDays, delivery: Truck };

// Today's jobs, appointments and supplier deliveries — one quiet list in time order.
export function Upcoming({ items, className = "", title = "Upcoming today" }) {
  return (
    <HomeSection title={title} count={items.length ? plural(items.length, "item") : null} testid="upcoming" className={className} action={<Link to="/dispatch/schedule" className="btn-ghost btn-sm" data-testid="upcoming-schedule-link">Schedule →</Link>}>
      {items.length === 0 ? <EmptyLine testid="upcoming-empty">Nothing scheduled for today.</EmptyLine> : (
        <div>
          {items.map((u, i) => { const I = ICON[u.kind] || CalendarDays; return (
            <Link key={i} to={u.link} className="list-row !py-2" data-testid={`upcoming-${u.kind}-${i}`}>
              <span className="t3 w-[68px] shrink-0 tnum text-[12px]">{u.at ? ftime(u.at) : u.time_window || "—"}</span>
              <I size={14} className="t4 shrink-0" />
              <span className="min-w-0 flex-1"><span className="t1 block truncate text-[13px] font-medium">{u.title}</span><span className="t3 block truncate text-[11.5px]">{u.sub}</span></span>
              {u.status && <Badge status={u.status} dot={false} className="hidden sm:inline-flex" />}
            </Link>
          ); })}
        </div>
      )}
    </HomeSection>
  );
}

const STATUS = { on_site: "On site", working: "Working", paused: "Paused", travelling: "Travelling", late: "Late", scheduled: "Scheduled", completed: "Finished", available: "Available" };

// Operations workspace: who is where right now.
export function TeamToday({ team, className = "" }) {
  const rows = (team.status || []).filter((t) => t.status !== "available");
  return (
    <HomeSection title="Team today" count={team.live ? `${team.live} on the move` : null} testid="team-today" className={className} action={<Link to="/team" className="btn-ghost btn-sm" data-testid="team-today-link">Live team →</Link>}>
      {rows.length === 0 ? <EmptyLine testid="team-today-empty">Nobody is clocked on right now.</EmptyLine> : (
        <div>
          {rows.slice(0, 8).map((t) => (
            <Link key={t.id} to={t.job_id ? `/jobs/${t.job_id}` : `/team/${t.id}`} className="list-row !py-2" data-testid={`team-today-${t.id}`}>
              <Avatar name={t.name} size="sm" />
              <span className="min-w-0 flex-1"><span className="t1 block truncate text-[13px] font-medium">{t.name}</span><span className="t3 block truncate text-[11.5px]">{t.job_number ? `${t.job_number} · ${t.job_title}` : "No job today"}{t.since ? ` · since ${ftime(t.since)}` : ""}</span></span>
              <span className={`t3 shrink-0 text-[12px] ${t.status === "late" ? "!text-red-600" : ""}`}>{STATUS[t.status] || t.status}</span>
            </Link>
          ))}
        </div>
      )}
    </HomeSection>
  );
}
